import React, { Component, ReactNode } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { styles } from "../utils/styles";
import {
  MenuItemEventHandler,
  TriggerEvent,
  StyleProps,
  InternalProps
} from "../types";

export interface ItemProps extends StyleProps, InternalProps {
  id: any;
  value: any;
  /**
   * @description
   */
  toggleState: any;
  /**
   * @description
   */
  onIcon: any;
  /**
   * @description
   */
  offIcon: string;
  /**
   * @description
   */
  shortcutKey: string;
  /**
   * @description Any valid node that can be rendered
   */
  children: ReactNode;
  /**
   * @description Passed to the `Item` onClick callback. Accessible via `props`
   */
  data?: object;

  /**
   * Disable or not the `Item`. If a function is used, a boolean must be returned
   */
  disabled: boolean | ((args: MenuItemEventHandler) => boolean);

  /**
   * Callback when the current `Item` is clicked. The callback give you access to the current event and also the data passed
   * to the `Item`.
   * `({ event, props }) => ...`
   */
  onClick: (args: MenuItemEventHandler) => any;
}

export interface ItemState {
  isOnState: any;
}
const noop = () => {};

class ToggleItem extends Component<ItemProps, ItemState> {
  static propTypes = {
    id: PropTypes.any,
    value: PropTypes.any,
    toggleState: PropTypes.any,
    onIcon: PropTypes.any,
    offIcon: PropTypes.string,
    shortcutKey: PropTypes.string,
    children: PropTypes.node.isRequired,
    data: PropTypes.object,
    disabled: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    onClick: PropTypes.func,
    nativeEvent: PropTypes.object,
    propsFromTrigger: PropTypes.object,
    className: PropTypes.string,
    style: PropTypes.object
  };

  static defaultProps = {
    id: "",
    value: "",
    toggleState: false,
    onIcon: "",
    offIcon: "",
    shortcutKey: "",
    disabled: false,
    onClick: noop
  };

  isDisabled: boolean;

  constructor(props: ItemProps) {
    super(props);
    const {
      disabled,
      nativeEvent,
      propsFromTrigger,
      data,
      toggleState
    } = this.props;

    this.state = {
      isOnState: toggleState
    };

    this.isDisabled =
      typeof disabled === "function"
        ? disabled({
            event: nativeEvent as TriggerEvent,
            props: { ...propsFromTrigger, ...data }
          })
        : disabled;
  }
  componentWillUpdate(nextProps: any) {
    (this.state.isOnState as any) = nextProps.toggleState;
  }
  handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    this.isDisabled
      ? e.stopPropagation()
      : this.props.onClick({
          event: this.props.nativeEvent as TriggerEvent,
          props: { ...this.props.propsFromTrigger, ...this.props.data }
        });
    let { isOnState } = this.state;
    isOnState = !isOnState;
    this.setState({ isOnState: isOnState });
  };

  renderIcon() {
    const { isOnState } = this.state;
    if (isOnState) {
      return this.props.onIcon;
    } else {
      return;
    }
  }

  render() {
    const { className, style, children, shortcutKey } = this.props;

    const cssClasses = cx(styles.item, className, {
      [`${styles.itemDisabled}`]: this.isDisabled
    });

    return (
      <div
        className={cssClasses}
        style={style}
        onClick={this.handleClick}
        role="presentation"
      >
        <div className={styles.leftAlign}>
          <div className={styles.itemIcon}>{this.renderIcon()}</div>

          <div className={styles.itemContent}>{children}</div>
        </div>
        {shortcutKey && (
          <div className={styles.rightAlign}>
            <div className={styles.itemShortcutKey}>{shortcutKey}</div>
          </div>
        )}
      </div>
    );
  }
}

export { ToggleItem };
